window.ReferenceAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    self.save = function (references) {


        var deferred = $q.defer();

        var referenceParam = [];
        _.each(references, function (reference) {
            referenceParam.push({
                "name": reference.name,
                "phone": reference.phone,
                "email": reference.email,
                "brand_name": reference.company
            });
        });


        _protected.request('reference', 'PUT', referenceParam).then(function (data) {
            _protected.handleResponse(data.data, deferred);
        }, function (err) {
            deferred.reject(err);
        });
        return deferred.promise;
    };

    self.loadReferences = function() {
        var defer = $q.defer();

        _protected.request("reference", "GET")
            .then(function(res){
                res = (res.data && res.data.data && res.data.data[0]) || [];
                defer.resolve(res);
            });
        return defer.promise;
    }

    self.addOrUpdate = async (references, referencesToDelete, source) => {
        var defer = $q.defer();

        var promises = [];
        let allResults = [];

        if (references[0] && !references[0].id && source === 'JOB_APPLY') {
            references[0].force = true;
            let firstCall = await  _protected.request("reference", "PUT", [references[0]]);
            allResults.push(firstCall);
            references.splice(0, 1);
        }

        references.forEach((reference, index) => {

            if (!reference) {
                return;
            }

            var promise;

            if (reference.id) {
                reference.reference_id = reference.id;
                promise = _protected.request("reference", "POST", reference);
            }
            else {
                promise = _protected.request("reference", "PUT", [reference]);
            }

            promises.push(promise);
        });

        if (referencesToDelete) {
            referencesToDelete.forEach(function(reference) {
                var promise = _protected.request("reference/" + reference.id, "DELETE");
                promises.push(promise);
            });
        }

        $q.all(promises).then(function(result){
            allResults = [...allResults, ...result];
            defer.resolve(allResults);
        });

        return defer.promise;
    }
});